var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('h1',{staticStyle:{"display":"none"}},[_vm._v("Exclusive Villa Monte Kope")]),_c('h2',{staticStyle:{"display":"none"}},[_vm._v("Find your perfect vacation here!")]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }